export var NotificationEndpointType;
(function (NotificationEndpointType) {
    NotificationEndpointType["Slack"] = "Slack";
    NotificationEndpointType["BigPanda"] = "BigPanda";
    NotificationEndpointType["Datadog"] = "Datadog";
    NotificationEndpointType["PagerDuty"] = "PagerDuty";
    NotificationEndpointType["ServiceNow"] = "ServiceNow";
    NotificationEndpointType["VictorOps"] = "VictorOps";
    NotificationEndpointType["Opsgenie"] = "Opsgenie";
    NotificationEndpointType["Custom"] = "Custom";
    NotificationEndpointType["MicrosoftTeams"] = "Microsoft Teams";
    NotificationEndpointType["MicrosoftTeamsWorkflow"] = "Microsoft Teams Workflow";
    NotificationEndpointType["OrionIqAgent"] = "OrionIQ Agent";
})(NotificationEndpointType || (NotificationEndpointType = {}));
export var NotificationEndpointNotificationSubject;
(function (NotificationEndpointNotificationSubject) {
    NotificationEndpointNotificationSubject["CreateNotificationEndpoint"] = "new-notification-endpoint-added";
})(NotificationEndpointNotificationSubject || (NotificationEndpointNotificationSubject = {}));
export var NotificationEndpointsSubjects;
(function (NotificationEndpointsSubjects) {
    NotificationEndpointsSubjects["NotificationEndpointsPage"] = "notification-endpoints-page";
    NotificationEndpointsSubjects["Table"] = "notification-endpoints-table";
    NotificationEndpointsSubjects["TableEmptyState"] = "table-empty-state";
    NotificationEndpointsSubjects["Modal"] = "notification-endpoints-modal";
    NotificationEndpointsSubjects["EndpointTypeSelect"] = "endpointType";
    NotificationEndpointsSubjects["EndpointTitleInput"] = "endpoint-title";
    NotificationEndpointsSubjects["EndpointDescriptionInput"] = "endpoint-description";
    NotificationEndpointsSubjects["EndpointUrlInput"] = "endpoint-url";
    NotificationEndpointsSubjects["OrionIqAgentSelect"] = "endpoint-orioniq-agent-select";
    NotificationEndpointsSubjects["OrionIqAgentApiTokenSelect"] = "endpoint-orioniq-agent-api-token-select";
    NotificationEndpointsSubjects["OrionIqAgentLogAccountsSelect"] = "endpoint-orioniq-agent-log-accounts";
    NotificationEndpointsSubjects["OrionIqAgentMetricAccountsSelect"] = "endpoint-orioniq-agent-metric-accounts";
})(NotificationEndpointsSubjects || (NotificationEndpointsSubjects = {}));
//# sourceMappingURL=notification-endpoints.enum.js.map